<script lang="ts">
import { stripSiteDomain } from '$lib/utils/url.js';
import Link from '../Link/Link.svelte';

interface Props {
    title?: string;
    headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    titleSize?: string;
    description?: string;
    linkText?: string;
    linkUrl?: string;
    hideBlock?: boolean;
}

let {
    title = '',
    headingLevel = 'h2',
    titleSize = 'h2',
    description = '',
    linkText = '',
    linkUrl = '',
    hideBlock = false,
}: Props = $props();

// Transform URL from Builder.io
const transformedLinkUrl = $derived(stripSiteDomain(linkUrl));
const titleSizeClassName = $derived(`flashy-callout__title--${titleSize}`);
</script>

{#if !hideBlock}
    <div class="flashy-callout">
        {#if title}
            <svelte:element this={headingLevel} class="flashy-callout__title {titleSizeClassName}">{title}</svelte:element>
        {/if}
        <div class="flashy-callout__body">
            {#if description}
                <p class="flashy-callout__description">{description}</p>
            {/if}
            {#if linkText && transformedLinkUrl}
                <Link to={transformedLinkUrl} type="link" class="button button--inverse flashy-callout__link">
                    {#snippet text()}
                                    {linkText}
                                {/snippet}
                </Link>
            {/if}
        </div>
    </div>
{/if}

<style lang="scss">
    @use '/src/scss/global-constants/typography';
    @use 'sass-mq/mq' as *;

    .flashy-callout {
        width: 100vw;
        margin-left: calc(50% - 50vw);
        margin-right: calc(50% - 50vw);
        background: var(--colour-pickled-pineapple);
        padding: 2.7rem var(--layout-pagegrid-margin) 5.2rem;

        @include mq($from: tabletLarge) {
            display: grid;
            gap: var(--layout-pagegrid-gutter);
            grid-template-columns: repeat(2, 1fr);
            padding: 10rem calc(var(--layout-pagegrid-margin));
        }

        &__title {
            max-width: 15ch;
            text-wrap: balance;
            margin-bottom: 2.4rem;

            @include mq($from: tabletLarge) {
                max-width: 20ch;
                margin-bottom: 0;
            }

            &--h1   { @include typography.display-xl; }
            &--h1-5 { @include typography.display-hero; }
            &--h2   { @include typography.display-lg; }
            &--h3   { @include typography.display-md; }
            &--h4   { @include typography.heading-lg; }
            &--h5   { @include typography.heading-md; }
        }

        &__description {
            max-width: 42rem;
            margin-bottom: 2.4rem;
            text-wrap: pretty;

            @include typography.text-feature;
        }
    }
</style>
